import { Spinner, SpinnerSize, Stack } from "@fluentui/react";
import "./Loading.css";

export function Loading() {
  return (
    <>
      <Stack className="spinner">
        <Spinner
          size={SpinnerSize.large}
          label="Loading..."
          ariaLive="assertive"
          labelPosition="right"
        />
      </Stack>
    </>
  );
}
